function Impact() {
  const years = [
    {
      year: 'Year 1', title: 'Foundation',
      stats: [
        { icon: 'fa-users', value: '400-500', label: 'Students Served' },
        { icon: 'fa-school', value: '2-3', label: 'School Partnerships' },
        { icon: 'fa-dollar-sign', value: '$5,000', label: 'Budget' },
      ],
      items: [
        '30-40 Dallas students walk into class on day one fully equipped',
        '40-50 Nepal students perform their first science experiments ever',
        '2-3 teachers trained to bring STEM alive in villages with no electricity',
        'First science fair in Dande village history—students showcase to parents',
      ],
    },
    {
      year: 'Year 2', title: 'Growth',
      stats: [
        { icon: 'fa-users', value: '100+', label: 'Students Served' },
        { icon: 'fa-school', value: '3-5', label: 'School Partnerships' },
        { icon: 'fa-dollar-sign', value: '$8,000', label: 'Budget' },
      ],
      items: [
        '100+ Dallas students equipped, tracked, and refilled when supplies run out',
        '3-4 Nepal schools with active labs—experiments happening in mountain classrooms',
        'Regional science fair across Ilam district—villages competing and learning',
        'Dallas tech professionals mentoring rural Nepal students via video',
      ],
    },
    {
      year: 'Year 3', title: 'Sustainability',
      stats: [
        { icon: 'fa-users', value: '500+', label: 'Students Served' },
        { icon: 'fa-school', value: '5+', label: 'School Partnerships' },
        { icon: 'fa-dollar-sign', value: '$10,000', label: 'Budget (Break Even)' },
      ],
      items: [
        '500+ Dallas students equipped annually—partnership with 5+ Title I schools',
        '5 Nepal schools with permanent STEM programs—500+ mountain students in labs',
        'Proven model replicated—other foundations adopt our blueprint',
        'Self-sustaining budget—ready to scale to 10 schools in Year 4',
      ],
    },
  ];

  return (
    <section className="impact" id="impact">
      <div className="container">
        <div className="section-header centered">
          <h2 className="section-title">From First Backpack to Permanent Labs</h2>
          <p className="section-subtitle">
            We're not here to run charity drives. We're building permanent infrastructure—labs
            that outlive us, programs that become tradition, and proof that underserved
            students can achieve anything when walls and geography stop being barriers.
          </p>
        </div>
        <div className="impact-timeline">
          {years.map((y, i) => (
            <div className="timeline-item" key={i}>
              <div className="timeline-marker">{y.year}</div>
              <div className="timeline-content">
                <h3>{y.title}</h3>
                <div className="impact-stats">
                  {y.stats.map((s, j) => (
                    <div className="impact-stat" key={j}>
                      <i className={`fas ${s.icon}`}></i>
                      <strong>{s.value}</strong>
                      <span>{s.label}</span>
                    </div>
                  ))}
                </div>
                <ul>
                  {y.items.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Impact;
